import { RiCloseLine } from '@remixicon/react';
import Flex from 'src/components/atoms/Flex';
import { AgButton } from 'src/components/ui';
import { useGridFilters } from '../../filters/useGridFilters';
import type { BaseGridStateWithHelpers } from '../../shared/baseGridTypes';
import FilterItem from './FilterItem';
import type { FilterColumn } from './filterItemTypes';

type Props = { columns: FilterColumn[]; enhancedGridState: BaseGridStateWithHelpers; chipTestIdPrefix?: string };

export default function FilterList({ columns, enhancedGridState, chipTestIdPrefix }: Props) {
  const { chips, removeFilter, updateFilter, clearFilters } = useGridFilters({
    columns,
    gridFilters: enhancedGridState.gridFilters,
    updateFilters: enhancedGridState.updateFilters,
  });

  if (!chips.length) return null;

  return (
    <Flex sx={{ alignItems: 'center', width: '100%', gap: 1, flexWrap: 'wrap' }}>
      <p>Filters:</p>
      {chips.map(({ filter, column }) => (
        <FilterItem
          key={filter.field}
          filter={filter}
          column={column}
          removeFilter={() => removeFilter(filter.field)}
          updateFilter={(filter) => updateFilter(filter.field, filter)}
          data-testid={chipTestIdPrefix ? `${chipTestIdPrefix}-${filter.field}` : undefined}
        />
      ))}
      <AgButton variant="destructive-ghost" shape="pill" aria-label="Clear all filters" onPress={clearFilters}>
        <RiCloseLine size={16} /> Clear All
      </AgButton>
    </Flex>
  );
}
